import type React from 'react';
import { type ReactNode, useState } from 'react';
import AkomiDialog from 'src/components/dialogs/AkomiDialog';
import AkomiDialogActions from 'src/components/dialogs/AkomiDialogActions';
import type { MetadataFieldFormik } from '../../types';

interface AdminFormModalProps {
  header: string;
  onClose: () => void;
  formik: MetadataFieldFormik;
  children: ReactNode;
}

const AdminFormModal: React.FC<AdminFormModalProps> = ({ header, onClose, formik, children }) => {
  const [isOpen, setIsopen] = useState<boolean>(true);
  const handleClose = (): void => {
    setIsopen(false);
    onClose();
    // handle some clean up
    formik.resetForm();
  };

  return (
    <AkomiDialog
      open={isOpen}
      onClose={handleClose}
      title={header}
      variant="form"
      maxWidth="sm"
      actions={
        <AkomiDialogActions
          variant="save-cancel"
          onPrimary={() => formik.handleSubmit()}
          onSecondary={handleClose}
          primaryDisabled={Object.keys(formik.errors).length > 0}
        />
      }
    >
      {children}
    </AkomiDialog>
  );
};

export default AdminFormModal;
